import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { IBreadCrumb } from '../../../types';

interface IProps {
  desc?: string,
  title: string,
  subtitle?: string,
  breadcrumb: IBreadCrumb[],
}

const Title: React.FC<IProps> = (props) => {
  const { title, subtitle, desc, breadcrumb } = props
  return (
    <TitleWrapper>
      <div className="inbox">
        <InboxPart>
          <div className="part">
            {desc && <div className="part-description">{desc}</div>}
            <div className="part-title">{title}</div>
            {subtitle && <div className="part-sub-title">{subtitle}</div>}
          </div>
        </InboxPart>
        <Pan className="clearfix">
          <li><Link to="/">HOME</Link></li>
          {breadcrumb.map((route, routeIndex) => (
            <li key={routeIndex}>
              {route.path
                ? <Link to={route.path}>{route.label}</Link>
                : <div className={routeIndex === breadcrumb.length - 1 ? "now" : ''}>{route.label}</div>
              }
            </li>
          ))}
        </Pan>
      </div>
    </TitleWrapper>
  );
};

const TitleWrapper = styled.div`
  border-bottom: 1px solid #e6e6e6;
  & .inbox {
    height: 80px;
    position: relative;
    line-height: none;
  }
  & h2 {
    width: 500px;
    height: 52px;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -26px;
    text-align: left;
  }
`;

const Pan = styled.ul`
  width: auto;
  position: absolute;
  right: 0;
  bottom: 5px;
  text-align: right;
  font-size: 8pt;
  & li {
    float: left;
    padding: 1px 20px;
    line-height: normal;
    background-position: left;
    background-color: #dad7cf;
    background-repeat: no-repeat;
    background-image: url('/images/breadcrumb/pan_back01.gif');
    & :first-child {
      padding: 1px 20px;
      background-position: left;
      background-repeat: no-repeat;
      background-image: url('/images/breadcrumb/pan_back03.gif');
    }
    & :last-child {
      padding: 0;
      background-position: left;
      background-color: #b7b1a4;
      background-repeat: no-repeat;
      background-image: url('/images/breadcrumb/pan_back02_r2_c2.gif');
      color: #fff;
      & .now {
        width: 100%;
        padding: 1px 20px;
        background-position: right;
        background-repeat: no-repeat;
        background-image: url('/images/breadcrumb/pan_back04.gif');
      }
    }
  }
  & a {
    display: block;
    color: #6b6454;
    text-decoration: none;
  }
  & a:hover {
    text-decoration: underline;
  }
`;

const InboxPart = styled.div`
  width: 100%;
  display: inline-block;
  margin: 14px 0 0 0;
  & .part {
    height: 60px;
    width: 600px;
    display: flex;
    border-left: #005daa solid 8px;
    flex-direction: column;
  }
  & .part-description {
    text-align: left;
    font-size: 1.2em;
    font-weight: 700;
    margin-left: 12px;
    color: #005daa;
  }
  & .part-title {
    text-align: left;
    font-size: 1.8em;
    font-weight: 900;
    margin-left: 12px;
    color: #005daa;
  }
  & .part-sub-title {
    text-align: left;
    margin: -5px 2px 4px 12px;
    color: #858585;
    font-size: 1.4em;
    font-weight: 900;
  }
`;


export default Title;
